module.exports = __webpack_public_path__ + "img/samplering@2x.5f4987d.webp";